import { useSearchParams } from 'react-router-dom';

// Reads the ?platform= query param ('shopify' | 'woocommerce' | '').
// Used to scope the Boutiques sub-sections (Produits, Synchro, Snippets, Tutoriels)
// to a single e-commerce platform.
const LABELS = { shopify: 'Shopify', woocommerce: 'WordPress / WooCommerce', custom: 'Sites Customs', ai: 'Sites IA' };
const OTHER = ['woocommerce', 'custom', 'ai'];

export function usePlatform() {
  const [params] = useSearchParams();
  const platform = params.get('platform') || '';
  const isWoo = platform === 'woocommerce';
  const isSimple = platform === 'custom' || platform === 'ai';
  const matchStore = (s) =>
    !platform || (platform === 'shopify' ? !OTHER.includes(s.platform) : s.platform === platform);
  const label = LABELS[platform] || '';
  return { platform, isWoo, isSimple, matchStore, label };
}
